import React from "react";

type HandIconProps = {
  className?: string;
  size?: number;
};

const HandIcon = ({ className, size = 18 }: HandIconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1" />
      <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2" />
      <path d="M10 10.5V5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v3" />
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-1.5-5.5-3.5" />
      <path d="M6 18a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2" />
    </svg>
  );
};

export default HandIcon;
